import { Phone, Sparkles } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { PHONE_DISPLAY, PHONE_LINK } from "@/lib/data";
import { scrollToId } from "@/App";

export const Header = () => {
  const navigate = useNavigate();
  const go = (id) => {
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 300);
    } else {
      scrollToId(id);
    }
  };
  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-amber-500/15 bg-[#0B1D14]/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5 sm:px-8">
        <button onClick={() => go("hero")} className="flex items-center gap-2.5" data-testid="header-logo">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-amber-400 to-amber-600 gold-glow">
            <Sparkles className="h-4.5 w-4.5 text-stone-950" size={18} />
          </span>
          <span className="font-display text-lg font-bold tracking-tight text-amber-50">
            Southern Christmas Co.
          </span>
        </button>
        <nav className="hidden items-center gap-7 font-mono-x text-[11px] uppercase tracking-[0.2em] text-emerald-100/70 lg:flex">
          <button onClick={() => go("packages")} className="transition-colors hover:text-amber-400" data-testid="nav-packages-link">Packages</button>
          <button onClick={() => go("gallery")} className="transition-colors hover:text-amber-400" data-testid="nav-gallery-link">Mockup Gallery</button>
          <button onClick={() => go("reviews")} className="transition-colors hover:text-amber-400" data-testid="nav-reviews-link">Reviews</button>
          <button onClick={() => go("how-it-works")} className="transition-colors hover:text-amber-400" data-testid="nav-how-link">How It Works</button>
          <Link to="/admin" className="transition-colors hover:text-amber-400" data-testid="header-admin-link">Admin</Link>
        </nav>
        <div className="flex items-center gap-3">
          <a
            href={PHONE_LINK}
            data-testid="header-phone-link"
            className="hidden items-center gap-2 rounded-full border border-amber-500/30 px-4 py-2 font-mono-x text-xs tracking-wider text-amber-300 transition-all hover:border-amber-400/60 hover:bg-amber-500/10 sm:flex"
          >
            <Phone size={13} />
            {PHONE_DISPLAY}
          </a>
          <button
            onClick={() => go("booking")}
            data-testid="header-book-button"
            className="rounded-full bg-gradient-to-r from-amber-500 to-amber-400 px-5 py-2 text-sm font-bold text-stone-950 transition-all hover:from-amber-400 hover:to-amber-300 gold-glow"
          >
            Book Installation
          </button>
        </div>
      </div>
    </header>
  );
};
